// @codekit-prepend "diviSliderCircle.js"
// @codekit-prepend "selectDropdown.js"

jQuery(function($){
	$('.et_pb_accordion .et_pb_toggle_open').addClass('et_pb_toggle_close').removeClass('et_pb_toggle_open');

	$('.et_pb_accordion .et_pb_toggle').click(function() {
		$this = $(this);
		setTimeout(function(){
			 $this.closest('.et_pb_accordion').removeClass('et_pb_accordion_toggling');
		},700);
	});
});

jQuery(function($){
  $('.et_pb_toggle_title').click(function(){
    var $toggle = $(this).closest('.et_pb_toggle');
    if (!$toggle.hasClass('et_pb_accordion_toggling')) {
      var $accordion = $toggle.closest('.et_pb_accordion');
      if ($toggle.hasClass('et_pb_toggle_open')) {
        $accordion.addClass('et_pb_accordion_toggling');
        $toggle.find('.et_pb_toggle_content').slideToggle(700, function() { 
          $toggle.removeClass('et_pb_toggle_open').addClass('et_pb_toggle_close'); 
					
        });
      }
      setTimeout(function(){ 
        $accordion.removeClass('et_pb_accordion_toggling'); 
      }, 750);
    }
  });
});


jQuery(document).ready(function($) {
  // Contact Form Click Event
  $('form.caldera_forms_form.CF5c803a44d9b28 input[type="submit"]').on('click', function(){
		console.log('Contact Form Logged');
	  dataLayer.push({'event': 'button1-click'});
	});
  // Gated Content Click Event
	$('form.caldera_forms_form.CF5c828d17340f9 input[type="submit"]').on('click', function(){
		console.log('Gated Content Form Logged');
	  dataLayer.push({'event': 'button2-click'});
	});
  // Landing Page Click Event
  $('form.caldera_forms_form.CF5c8140bfafb58 input[type="submit"]').on('click', function(){
		console.log('Landing Page Form Logged');
	  dataLayer.push({'event': 'button3-click'});
	});


})